(ns frontend.view.modals.risk-editor.events
  (:require
   [basic-components.attachments :as attachments-view]
   [frontend.actions.attachment :as attachment-actions]
   [frontend.actions.common :as common-actions]
   [frontend.actions.entity :as entity-actions]
   [common.localization :as loc]
   [common.util :as cu :refer [remove-empty-vals]]
   [clojure.string :as string]
   [frontend.logging :as logging]))

(defn reset-state!
  [state error-state alert-state entity-type mandatory-fields entity]
  (reset! state {:start-time   0
                 :selected-tab :frontend.view.modals.risk-editor.view/properties})
  (reset! error-state nil)
  (reset! alert-state nil)

  (swap! state assoc
    :entity-type entity-type
    :mandatory-fields mandatory-fields))

(defn validate-form
  [entity view-state]
  ;; todo comments for what this returns (displayable error texts that are shown to user)
  (let [mandatory-fields (:mandatory-fields @view-state)
        ;; todo - merge live updates and draft-entity to have single data source
        errors (:errors @view-state)]
    (->> (flatten [(some->> errors
                            (remove nil?)
                            (map second))
                   (->> mandatory-fields
                        (map (fn [mf]
                               (let [blank-value? (cu/blank-value? (get entity mf))]
                                 (when blank-value?
                                   mf))))
                        (remove nil?)
                        (map (fn [kv]
                               (loc/tr :mandatory-field/value-not-set [(loc/tr kv)]))))])
         (remove nil?))))


(defn add-attachment-to-entity!
  [{:keys [state db/id on-success! on-error!]} {:keys [files original-event]}]
  (when (aget files 0)
    (let [file (aget files 0)
          name (.-name file)
          size (.-size file)
          attachment (merge {:filename name
                             :file     file}
                            (when id
                              {:target id}))
          token-success!
          (fn [token]
            (attachments-view/add-indicator! state token name size)
            (attachment-actions/*=>add-attachment
             {:multipart-params (assoc attachment :token token)}
             (fn [resp]
               (attachments-view/remove-indicator! state token)
               (on-success! (:body resp)))
             (fn [resp]
               (on-error! (:body resp))
               (attachments-view/show-indicator-error! state
                                                       token
                                                       (loc/tr :attachment-indicator-error)))))]
      (common-actions/*<-create-op-token nil
                                         token-success!
                                         (fn [e]
                                           (logging/error "resp token=" e))))))
